import React from "react";
import Menu from "@mui/material/Menu";
import SoftBox from "components/SoftBox";
import DefaultNavbarLink from "examples/Navbars/DefaultNavbar/DefaultNavbarLink";

interface Page {
  page_name: string;
  page_route: string;
  icon?: string;
  [key: string]: any;
}

interface DefaultNavbarMobileProps {
  open: HTMLElement | null;
  close: () => void;
  pagesData: Page[];
}

const DefaultNavbarMobile: React.FC<DefaultNavbarMobileProps> = ({
  open,
  close,
  pagesData,
}) => {
  const width = open ? open.getBoundingClientRect().width : 0;

  return (
    <Menu
      anchorEl={open}
      open={Boolean(open)}
      onClose={close}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      MenuListProps={{ style: { width: `calc(${width}px - 4rem)` } }}
    >
      <SoftBox px={0.5}>
        <DefaultNavbarLink
          icon="donut_large"
          name="Home"
          route="/home"
          light={false}
        />
        <DefaultNavbarLink
          icon="account_circle"
          name="Employee Sign in"
          route="/employee/sign-in"
          light={false}
        />

        {pagesData?.map((page, index) => (
          <DefaultNavbarLink
            key={index}
            icon={page.icon || "info"}
            name={page.page_name}
            route={`/${page.page_route}`}
            light={false}
          />
        ))}
      </SoftBox>
    </Menu>
  );
};

export default DefaultNavbarMobile;
